import { createAsyncThunk } from "@reduxjs/toolkit";
import { globalErrorMessage } from "../../data/globalErrorMessages";

export const loadGlobalMessage = createAsyncThunk(
    "globalMessages/messages",
    async () => {
        return globalErrorMessage
    }
)